import { RawChartData } from "&/types/layout-workspace/components/chart-output/typings/raw-chart-data.type";
import { ChartTemplateDocument } from "@wave-charts/core/dist/src/storage/interfaces/chart-template.interface";
import JSON5 from "json5";

/**
 * 获取初始的模版配置
 *
 * @param {ChartTemplateDocument} chartTemplate
 * @returns {Promise<Record<string, any>>}
 */
export async function getTemplateRawChartData(
  chartTemplate: ChartTemplateDocument,
): Promise<RawChartData> {
  const serializedData = await chartTemplate
    .getAttachment("data.json5")
    .getStringData();
  return JSON5.parse(serializedData);
}
